import Spacer from '@berlitz/spacer'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { EmptyInstructorsWrapper } from './style'

const EmptyInstructors: React.FC<{ past?: boolean; blocked?: boolean }> = ({ past, blocked }) => {
  const intl = useIntl()
  return (
    <>
      <Spacer size="md" />
      <EmptyInstructorsWrapper>
        <div>
          <img src={'/images/note.svg'} alt={intl.formatMessage({ id: 'No instructors found.' })} width={'100%'} />
        </div>
        <div>
          {past ? (
            <div>
              <FormattedMessage
                id="You currently have no past instructors."
                defaultMessage="You currently have no past instructors."
              />
            </div>
          ) : blocked ? (
            <div>
              <FormattedMessage
                id="You currently have no blocked instructors."
                defaultMessage="You currently have no blocked instructors."
              />
            </div>
          ) : (
            <>
              <div>
                <FormattedMessage
                  id="You currently have no favourites."
                  defaultMessage="You currently have no favourites."
                />
              </div>
              <div>
                <FormattedMessage
                  id="Use the options below to discover instructors."
                  defaultMessage="Use the options below to discover instructors."
                />
              </div>
            </>
          )}
        </div>
      </EmptyInstructorsWrapper>
    </>
  )
}

export default EmptyInstructors
